import React from "react";

import Carousel from "components/common/Carousel";

import useWindowSize from "hooks/useWindowSize";

import envs from "config/envs";

import * as S from "./SectionExecutive.Style";

const cardsList = [
  {
    id: 1,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/director-profile-image-01.webp`,
    imageAlt:
      "Mulher sorridente com cabelos castanhos curtos, usando uma blusa azul e colar prateado, posando em ambiente interno com fundo desfocado.",
    name: "Sany Silveira",
    description: "Diretora Presidente da CNP Seguros Holding Brasil",
  },
  {
    id: 2,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/director-profile-image-02.webp`,
    imageAlt:
      "Homem de expressão séria, vestindo paletó escuro e camisa azul clara, posando contra fundo neutro.",
    name: "Marco Pires",
    description: "Diretor Financeiro",
  },
  {
    id: 3,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/director-profile-image-04.webp`,
    imageAlt:
      "Homem de meia-idade com cabelos curtos e grisalhos, vestindo terno azul e camisa clara, sentado em cadeira de escritório, com fundo azul claro.",
    name: "Jorge Alves",
    description: "Diretor de Riscos e Controles Internos",
  },
];

const SectionExecutive = () => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 768;

  return (
    <S.SectionExecutiveContainer>
      <S.SectionExecutiveContent className="container">
        <S.SectionExecutiveBlock>
          <S.SectionExecutiveBlockTitle>
            Diretoria Executiva
          </S.SectionExecutiveBlockTitle>

          <S.SectionExecutiveBlockDescription>
            Nossa <strong>Diretoria Executiva</strong> estatutária é formada por
            membros selecionados com base nas normas do nosso Estatuto Social e
            no acordo entre acionistas. A seleção dos diretores considera
            exigências legais e o perfil de habilidades que prioriza a
            experiência e o conhecimento do mercado segurador.{" "}
            <strong>Confira quem são!</strong>
          </S.SectionExecutiveBlockDescription>
        </S.SectionExecutiveBlock>

        <Carousel
          noControls={!isMobile}
          numberOfSlidersToDisplay={isMobile ? 1 : 4}
          spacingToSlider={40}
          justifyContentOfSlider={isMobile ? "center" : "space-between"}
          children={cardsList.map((cardItem) => (
            <S.SectionExecutiveCard
              key={cardItem?.id}
              data-label="executive card"
            >
              <S.SectionExecutiveCardImage
                src={cardItem.image}
                alt={cardItem?.imageAlt ?? ""}
                loading="lazy"
              />

              <S.SectionExecutiveCardContent>
                <S.SectionExecutiveCardTitle>
                  {cardItem.name}
                </S.SectionExecutiveCardTitle>

                <S.SectionExecutiveCardDescription>
                  {cardItem.description}
                </S.SectionExecutiveCardDescription>
              </S.SectionExecutiveCardContent>
            </S.SectionExecutiveCard>
          ))}
        />
      </S.SectionExecutiveContent>
    </S.SectionExecutiveContainer>
  );
};

export default SectionExecutive;
